import { createSelector } from 'reselect';
import { DEVICES } from '../constants/device.constants';
import { initialState } from '../reducers/device.reducer';
import {ADMIN_PAGE} from "../../containers/AdminPage/constants";
import {fromJS, List} from "immutable";

const selectState = state => state?.[DEVICES] || initialState;
const selectAdminState = state => state?.[ADMIN_PAGE] || fromJS({});

const selectDevicesData = createSelector(
	selectState,
	state => state.get('data')
);

const selectDevicesList = createSelector(
	[selectDevicesData, selectAdminState],
	(data, adminState) => {
		const devices = data.toList();
		if(!devices?.size) {
			return List(adminState.get('devices'));
		}
		return devices;
	}
);

const selectTrackSingleDeviceId = createSelector(
	selectState,
	state => state.get('trackSingleDeviceId')
);

const selectFilteredDevices = createSelector(
	[selectDevicesList, selectTrackSingleDeviceId],
	(devices, trackSingleDeviceId) => {
		if (!trackSingleDeviceId) return devices;
		return devices.filter(d => d.id === trackSingleDeviceId);
	}
);

export const selectDevices = createSelector(
	selectFilteredDevices,
	devices => devices.sortBy(d => (d.accountName + d.name).toLowerCase())
);

export const selectDevicesFetched = createSelector(
	selectState,
	state => state.get('fetched')
);

export const selectSelectedDevice = createSelector(
	selectState,
	state => state.get('selectedDevice')
);

export const selectDevConOpen = createSelector(
	selectState,
	state => state.get('devConOpen')
);

export const selectMigratingDeviceId = createSelector(
	selectState,
	state => state.get('migratingDeviceId')
);

export const selectDevConStatus = createSelector(
	selectState,
	state => state.get('devConStatus')
);